import './style.scss';
import { Level, type IOccupancy } from '../../../models/occupancy.model';
import { TranslationService } from '../../../services/translation.service';
import DataUrlHelper from '../../../helpers/data-url.helper';
import occupancyNoInformationIcon from '../../../../assets/icons/crowding/crowding-level-0-rectangle-gray-900.svg';
import occupancyLowInformationIcon from '../../../../assets/icons/crowding/crowding-level-1-rectangle-gray-900.svg';
import occupancyMediumInformationIcon from '../../../../assets/icons/crowding/crowding-level-2-rectangle-gray-900.svg';
import occupancyHighInformationIcon from '../../../../assets/icons/crowding/crowding-level-3-rectangle-gray-900.svg';

function getHasOccupancy(occupancy: IOccupancy): boolean {
  return !!occupancy && (occupancy.level === Level.low || occupancy.level === Level.medium || occupancy.level === Level.high);
}

function createOccupancyText(occupancy: IOccupancy): string {
  if (!getHasOccupancy(occupancy)) return TranslationService.get('travelplanner.occupancy.nooccupancytext');
  if (occupancy.level === Level.low) return TranslationService.get('travelplanner.occupancy.lowoccupancytext');
  if (occupancy.level === Level.medium) return TranslationService.get('travelplanner.occupancy.mediumoccupancytext');
  return TranslationService.get('travelplanner.occupancy.highoccupancytext');
}

function getIconUrl(occupancy: IOccupancy): string {
  if (!getHasOccupancy(occupancy)) return DataUrlHelper.encode(occupancyNoInformationIcon);
  if (occupancy.level === Level.low) return DataUrlHelper.encode(occupancyLowInformationIcon);
  if (occupancy.level === Level.medium) return DataUrlHelper.encode(occupancyMediumInformationIcon);
  return DataUrlHelper.encode(occupancyHighInformationIcon);
}

function Occupancy({ occupancy, showAltText = false, className }: { occupancy: IOccupancy; showAltText?: boolean; className?: string }) {
  const occupancyText = createOccupancyText(occupancy);
  return (
    <div className={`occupancy d-flex ${className ?? ''}`}>
      <img className={`occupancy__icon ${!showAltText ? 'pe-1 occupancy__icon--non-alt-text' : ''}`} alt={showAltText ? occupancyText : ''} src={getIconUrl(occupancy)} />
      {!showAltText && <div>{occupancyText}</div>}
    </div>
  );
}

export default Occupancy;
